import { PaymentErrorPage } from '@/app/pages/errors/payment-error-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useGetBookingStatus } from '@/features/booking/hooks/use-get-booking-status';

export const Route = createFileRoute('/error/payment-error')({
  validateSearch: z.object({ number: z.string().regex(/^\d{8}-\d{4}-\d{8}$/) }),
  loaderDeps: ({ search }) => ({ ...search }),
  component: PaymentErrorPage,
  loader: async ({ context: { queryClient, bookingRepository }, deps }) => {
    const data = await queryClient.ensureQueryData(
      useGetBookingStatus.options({ repository: bookingRepository, ...deps }),
    );
    return { data };
  },
});
